/******************************************************************************
 *** BgtBrAllAtrzPrgrsInq ** 지부 결재진행 조회 (E1 / F1 / G1 공통)
*******************************************************************************/
import React from "react";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import StyledTabs from "@/js/common/ui/StyledTabs";
import { Tab, TabList, TabPanel } from "react-tabs";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import TextBox from "@/js/common/ui/input/TextBox";
import BgtSpcPrgrsDpstList from "./BgtBrPrgrsDpstList";
import BgtSpcPrgrsExpndList from "./BgtBrPrgrsExpndList";

interface Props {
    systemCode: string;
}

const BgtBrAllAtrzPrgrsInq = ({ systemCode }: Props) => {
    const userInfo = useRecoilValue(Atom.userInfo);

    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd);
    const [ognzCd, setOgnzCd] = React.useState<string>(userInfo.ognzCd);
    const [acntgYear, setAcntgYear] = React.useState<string>(Util.getNowAcntgYear());
    const [searchKywd, setSearchKywd] = React.useState<string>("");
    const [searchAtrzSttsCd, setSearchAtrzSttsCd] = React.useState<string>("03");
    const [tabIndex, setTabIndex] = React.useState<number>(0);

    const getTitle = () => {
        if (systemCode === "E1") return "지부 운영비 결재진행 조회";
        if (systemCode === "F1") return "지부장 직무활동비 결재진행 조회";
        if (systemCode === "G1") return "지부 대회비 결재진행 조회";
        return "결재진행 조회";
    };

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">

            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">{getTitle()}</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색조건 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">

                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6"
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택" paddingRight={8}
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">진행상태</span>
                        <SelectBox value={searchAtrzSttsCd}
                            width={140} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("ATRZ_STTS_CD").filter(item => item.code === '03' || item.code === '05'))}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setSearchAtrzSttsCd(data)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">적요</span>
                        <TextBox value={searchKywd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="검색어 입력"
                            onChangeFunc={(text: string) => setSearchKywd(text)}
                        />
                    </div>

                </div>
            </div>

            {/* 수입/지출 */}
            <StyledTabs selectedIndex={tabIndex} className="mb10 tabFit">
                <TabList>
                    <Tab onClick={() => setTabIndex(0)}>수입 결의서</Tab>
                    <Tab onClick={() => setTabIndex(1)}>지출 결의서</Tab>
                </TabList>

                <TabPanel>
                    <BgtSpcPrgrsDpstList
                        ognzCd={ognzCd}
                        acntgYear={acntgYear}
                        systemCode={systemCode}
                        searchKywd={searchKywd}
                        searchAtrzSttsCd={searchAtrzSttsCd}
                    />
                </TabPanel>

                <TabPanel>
                    <BgtSpcPrgrsExpndList
                        ognzCd={ognzCd}
                        acntgYear={acntgYear}
                        systemCode={systemCode}
                        searchKywd={searchKywd}
                        searchAtrzSttsCd={searchAtrzSttsCd}
                    />
                </TabPanel>
            </StyledTabs>

        </div>
    );
};

export default BgtBrAllAtrzPrgrsInq;